import { WRAPPER } from '@/shared/styles/themes';
import { styled } from 'styled-components';

export const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 1132px;
  width: 100%;
  gap: 36px;
  //height: 100%;
`;
export const ScreenBlock = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: calc(100dvh - 74px);
`;
export const GameBlock = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  width: 100%;
  height: calc(100dvh - 74px);
`;
export const StartMenu = styled.div`
  display: flex;
  position: absolute;
  flex-direction: column;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  gap: 30px;
  border-radius: 8px 8px 0 0;
  background: linear-gradient(
    0deg,
    rgba(39, 38, 43, 0.85) 0%,
    rgba(39, 38, 43, 0.85) 100%
  );
`;
export const ButtonsContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
`;
export const GameStartButton = styled.div`
  display: flex;
  flex: 1 1 auto;
  height: 48px;
  width: 160px;
  padding: 12px 16px 12px 14px;
  justify-content: center;
  align-items: center;
  //gap: 6px;
  align-self: stretch;
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  //z-index: 1000;
  background: #625a63;
  //max-width: 130px;
  ${({ $action }) =>
    $action === 'play' &&
    `
    max-width: 240px;
    background: linear-gradient(89deg, #FF9500 0.66%, #FF5E00 116.39%);
  `}
`;

export const Wrapper = styled.div<{ isFullscreen: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  //align-items: flex-start;

  .game-iframe {
    display: flex;
    width: 100%;
    height: 100%;
    border: none;
  }

  width: 100%;
  height: ${({ $isFullscreen }) =>
    $isFullscreen ? 'calc(100dvh + 1px)' : '100%'};
  min-height: ${({ $isFullscreen }) =>
    $isFullscreen ? 'calc(100dvh + 1px)' : '100%'};
  display: ${({ $isExit }) => $isExit && 'none'};

  @media (min-width: 1024px) {
    height: ${({ $isFullscreen }) =>
      $isFullscreen ? 'calc(100dvh + 1px)' : '100%'};
    min-height: ${({ $isFullscreen }) =>
      $isFullscreen ? 'calc(100dvh + 1px)' : '100%'};
    display: ${({ $isExit }) => $isExit && 'none'};
  }
`;
export const IframePaddingContainer = styled.div`
  display: flex;
  width: 100%;
  height: 100%;

  @media (orientation: landscape) {
    //@media (max-width: 1024px) and (orientation: landscape) {
    //  padding: 12px;
  }
  @media (orientation: portrait) {
    //@media (max-width: 1024px) and (orientation: portrait) {
    //  padding: 18px;
  }
`;
export const IframeRoundContainer = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  border-radius: 8px;
  overflow: hidden;

  @media (orientation: landscape) {
    //@media (max-width: 1024px) and (orientation: landscape) {
    border-radius: 8px;
    overflow: hidden;
  }
  @media (orientation: portrait) {
    //@media (max-width: 1024px) and (orientation: portrait) {
    border-radius: 8px;
    overflow: hidden;
  }
`;
export const GameUiContainer = styled.div`
  display: flex;
  padding: 0px 24px 0px 10px;
  justify-content: space-between;
  width: 100%;
  height: 60px;
  align-items: center;
  border-radius: 0px 0px 8px 8px;
  background: #27262b;
`;
export const GameUiSubContainer = styled.div`
  display: flex;
  align-items: center;
`;
export const FullscreenButton = styled.button`
  display: flex;
  width: 40px;
  height: 40px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 8px;
  background: #3d3c41;
`;
export const FullScreenImage = styled.div`
  display: flex;
  width: 24px;
  height: 24px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  background-image: url('/images/icons/jackpot/full-screen.svg');
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
`;
export const FavoriteButton = styled.button`
  display: flex;
  width: 40px;
  height: 40px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 8px;
  background: #27262b;
`;
export const FavoriteImage = styled.div`
  display: flex;
  width: 24px;
  height: 24px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  background-image: url('/images/icons/heart-unfilled-ver2.svg');
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
`;
export const DemoSwitcher = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;
